var MODULEFILTER = (function(library, $) {

    var getFacetValue = function(facet) {
        var facetValue = null;
        if (facet.is(':checkbox')) {
            if (facet.is(':checked')) {
                facetValue = facet.val();
            } else {
                facetValue = "";
            }
        } else {
            facetValue = facet.val();
        }
        return facetValue;
    };

    var initEvents = function() {
        $('.filterFormField').on('change', function(event) {
            var params = fillParams();

            if ($(event.target).data("facet") === "brand" && params["name"]) {
                params["name"] = "";
            }

            if ("vehicleTypes" === event.target.dataset.facet &&
                ("MO" === params["vehicleTypes"] || "OFF" === params["vehicleTypes"])){
                params["vehicleSubtype"] = "";
            }

            if ($(event.target).data("facet") === "name" &&
                ($(event.target).hasClass('available') || $("option:selected", $(event.target)).hasClass('available'))) {
                params["fuzzyName"] = false;
            }

            facetChanged(params, event.target.dataset.searchurl);
        });

        saveTyreLastSearch(window.location.href)
    };

    var fillParams = function () {
        var params = {};
        $('.filterFormField').each(function(index, value){

            if ($(value).data("facet") != undefined) {
                var booleanFacet = $(value).data("facet");
                params[booleanFacet] = getFacetValue($(value));
                if (booleanFacet === "businessReviews" || booleanFacet === "eco") {
                    params[booleanFacet] = (params[booleanFacet] === 'true')
                }
                if (booleanFacet === "homologation") {
                    params["approvedBy"] = getFacetValue($(value));
                }
            }
        });

        params["clientReviewsRating"] = $(".result-input-clientReviewsRating:checked").val();
        if ($(".result-input-vehicle-subtype:checked").val() !== undefined) {
            params["vehicleSubtype"] = $(".result-input-vehicle-subtype:checked").val();
        }

        return params;
    };

    var facetChanged = function(params, searchUrl) {
        if (arguments.length === 1 || !searchUrl) {
            searchUrl = library.REIFEN.API.CALL_SEARCH.url;
        }
        var url = getSearchUrl(params);
        //reset pagination when facet is changed
        url = library.removeVariableFromURL(url, "pageNoFull");

        url = $.context + searchUrl + "?" + url;
        if($(".preselectedCar-ab-testing").length > 0) {
            window.location.href = url + "&enablePreselectedCarAB=true";
        } else {
            window.location.href = url;
        }
    };

    var getSearchUrl = function(params) {
        // replace current url with new params
        var queryParameters = {};
        var queryString = "";

        var filterForm = $('#filterForm');
        if (filterForm.is('form')) {
            queryString = $.map(filterForm.serializeArray(), function(val) {
                return [val.name, encodeURIComponent(val.value)].join('=');
            }).join('&');
        }

        var re = /([^&=]+)=([^&]*)/g, m;

        var pcrVehicleTypes = new Array();
        var llkwVehicleTypes = new Array();
        var motoVehicleTypes = new Array();
        var vehicleTypeGroups = new Array();
        var vehicleTypes = new Array();
        while (m = re.exec(queryString)) {
            if ("vehicleTypes" == library.urlDecode(m[1]) && library.urlDecode(m[2]) != "") {
                vehicleTypes.push(library.urlDecode(m[2]));
            } else if ("pcrVehicleTypes" == library.urlDecode(m[1])) {
                pcrVehicleTypes.push(library.urlDecode(m[2]));
            } else if ("llkwVehicleTypes" == library.urlDecode(m[1])) {
                llkwVehicleTypes.push(library.urlDecode(m[2]));
            } else if ("motoVehicleTypes" == library.urlDecode(m[1])) {
                motoVehicleTypes.push(library.urlDecode(m[2]));
            } else if ("vehicleTypeGroups" == library.urlDecode(m[1])) {
                vehicleTypeGroups.push(library.urlDecode(m[2]));
            } else {
                queryParameters[library.urlDecode(m[1])] = library.urlDecode(m[2]);
            }
        }

        queryParameters["pcrVehicleTypes"] = pcrVehicleTypes;
        queryParameters["llkwVehicleTypes"] = llkwVehicleTypes;
        queryParameters["motoVehicleTypes"] = motoVehicleTypes;
        queryParameters["vehicleTypeGroups"] = vehicleTypeGroups;

        for (var param in params) {

            if("vehicleTypeGroup" === param && params[param] === "LLKW") {
                queryParameters["cTire"] = "*";
            }

            if ("vehicleTypes" === param && !(vehicleTypes.indexOf(params[param]) !== -1) && params[param] != "") {
                vehicleTypes.push(params[param]);
            }

            if (vehicleTypes.indexOf("MO") < 0 && vehicleTypes.indexOf("OFF") < 0 && "vehicleSubtype" == param) {
                if ((vehicleTypes.indexOf("SL") < 0 ? 0 : 1) + (vehicleTypes.indexOf("FB") < 0 ? 0 : 1) !== vehicleTypes.length) {
                    vehicleTypes = [];
                }
                queryParameters[param] = params[param];
            } else {
                queryParameters[param] = params[param];
            }
        }

        queryParameters["vehicleTypes"] = vehicleTypes;

        var url = $.param(queryParameters, true);

        return url;
    };

    var minPrice = parseInt($('#minPrice').val()) || 0;
    var maxPrice = parseInt($('#maxPrice').val()) || 0;
    var availableMinPrice = parseInt($('#availableMinPrice').val()) || minPrice;
    var availableMaxPrice = Math.ceil(parseFloat($('#availableMaxPrice').val()) || maxPrice);

    var commonCurrency = $('#commonCurrency').val();
    var priceDecimalSeparator = $('#priceDecimalSeparator').val();
    var priceGroupingSeparator = $('#priceGroupingSeparator').val();
    var isCurrencySymbolAfterValue = $('#isCurrencySymbolAfterValue').val();

    if (!minPrice) {
        minPrice = availableMinPrice;
        maxPrice = availableMaxPrice;
    }

    var arraySliderValue = [availableMinPrice, minPrice, maxPrice, availableMaxPrice].sort(function compareNumbers(a, b) {
        return a - b;
    });

    var initPriceLabels = function () {
        $('#price1').html(formatPrice(minPrice, commonCurrency, priceDecimalSeparator, priceGroupingSeparator, isCurrencySymbolAfterValue));
        $('#price2').html(formatPrice(maxPrice, commonCurrency, priceDecimalSeparator, priceGroupingSeparator, isCurrencySymbolAfterValue));
    };

    var formatPrice = function (price, currency, priceDecimalSeparator, priceGroupingSeparator, currencyLast) {
        var tokens = Number(price).toFixed(0).split(".");
        var i = tokens[0];
        var j = (j = i.length) > 3 ? j % 3 : 0;
        var intPart = (j ? i.substr(0, j) + priceGroupingSeparator : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + priceGroupingSeparator);

        if (tokens[1]) {
            intPart += priceDecimalSeparator + "<sup>" + tokens[1] + "</sup>";
        }

        if (currencyLast == "true") {
            intPart = intPart + " " + currency;
        } else {
            intPart = currency + " " + intPart;
        }
        return intPart;
    };

    var updatePriceLabels = function (from, to) {
        $('#price1').html(formatPrice(from, commonCurrency, priceDecimalSeparator, priceGroupingSeparator, isCurrencySymbolAfterValue));
        $('#price2').html(formatPrice(to, commonCurrency, priceDecimalSeparator, priceGroupingSeparator, isCurrencySymbolAfterValue));
    };

    $('#slider-range').slider({
        range: true,
        min: arraySliderValue[0],
        max: arraySliderValue[3],
        values: [minPrice, maxPrice],
        slide: function (event, ui) {
            updatePriceLabels(ui.values[0], ui.values[1]);
        },
        stop: function (event, ui) {
            var params = fillParams();
            var priceFrom = ui.values[0];
            var priceTo = ui.values[1];
            params["minPrice"] = (priceFrom === 0 ? "" : priceFrom);
            params["maxPrice"] = (priceTo === 0 ? "" : priceTo);

            facetChanged(params);
        }
    });

    var resetFilters = function () {

        $("input:radio[name=clientReviewsRating]:first").attr('checked', true);

        let propertiesInputs = $("#facettenfilter_heading_optionals :input");
        for (let i = 0; i < propertiesInputs.length; i++) {
            propertiesInputs[i].checked = false;
        }

        $('#minPrice').val("");
        $('#maxPrice').val("");

        var necessaryFacets = ["width", "profile", "size"];
        $('.facettenfilter_element select.filterFormField').each(function (index, filterElement) {
            var facetName = $(filterElement).data("facet");
            if (facetName !== undefined && !(necessaryFacets.includes(facetName))) {
                $(filterElement).prop('selectedIndex', 0);
            }
        });
        var params = fillParams();
        facetChanged(params);
    };


    library.facetChanged = facetChanged;
    library.fillParams = fillParams;
    library.initEvents = initEvents;
    library.resetFilters = resetFilters;
    library.initPriceLabels = initPriceLabels;

    return library;

}(MODULE || {}, jQuery));

var FilterABTestingJS = (function ($) {

    var loadIndexSelector = $("#load-index");
    var fullVariantOptions = loadIndexSelector.find(".load-index-full-variant");
    var shortVariantOptions = loadIndexSelector.find(".load-index-short-variant");

    function hideFullLoadIndex() {
        loadIndexSelector.find(".load-index-full-variant").remove();
        loadIndexSelector.find(".load-index-short-variant").remove();
        loadIndexSelector.append(shortVariantOptions);
        loadIndexSelector.val($("#load-index option:selected").val());
    }

    function showFullLoadIndex() {
        var selectedValue = $("#load-index option:selected").val();
        loadIndexSelector.find(".load-index-short-variant").remove();
        loadIndexSelector.find(".load-index-full-variant").remove();
        loadIndexSelector.append(fullVariantOptions);
        loadIndexSelector.find(".load-index-full-variant").show();
        loadIndexSelector.val(selectedValue);
    }

    return {
        hideFullLoadIndex: hideFullLoadIndex,
        showFullLoadIndex: showFullLoadIndex
    }

})($);

$(document).ready(function () {

    if ($("#load-index").length) {
        FilterABTestingJS.hideFullLoadIndex()
    }
    
    if ($("#filterForm").length) {
        MODULEFILTER.initEvents();
    }

    if ($('#slider-range').length) {
        MODULEFILTER.initPriceLabels();
    }

    $('#reset_filters').on("click", function (event) {
        MODULEFILTER.resetFilters();
    });
    $('.search-filters-reset-anchor').on("click", function (event){
        event.preventDefault();
        $(this).prev('div').find('select').val("");
        $('#filterForm').trigger('submit');
    });
    $('.price-filters-reset-anchor').on("click", function (event){
        event.preventDefault();
        $('#minPrice').val("");
        $('#maxPrice').val("");
        $('#filterForm').trigger('submit');
    });
    $('.info-filters-reset-anchor').on("click", function (event){
        event.preventDefault();
        $(this).parent().find(":input").prop('checked', false);
        $('#filterForm').trigger('submit');
    });
});